import Dexie from 'dexie';

const db = new Dexie('CampaignDrafts');
db.version(1).stores({
  drafts: 'campaign_id, content, last_modified, sync_status'
});

export const saveDraftToStorage = async (id, content) => {
  try {
    await db.drafts.put({
      campaign_id: Number(id),
      content,
      last_modified: Date.now(),
      sync_status: 'pending'
    });
  } catch (e) {
    console.log(e.message);
  }
};

export const fetchDraftFromStorage = async (id) => {
  try {
    const draft = await db.drafts.get(Number(id));
    return draft || null;
  } catch (e) {
    console.log(e.message);
  }
};

export const deleteDraftFromStorage = async (id) => {
  try {
    await db.drafts.delete(Number(id));
  } catch (e) {
    console.log(e.message);
  }
};
